import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IsGranted} from '../../../../decorator/is-granted';
import {MetaTitle} from '../../../../decorator/meta-title';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {LoaderService} from '../../../../services/loader/loader.service';
import {LeadService} from '../../../../services/lead/lead.service';
import {KeyValuePipe, NgClass, NgOptimizedImage} from '@angular/common';
import {forkJoin} from 'rxjs';
import {LangService} from '../../../../services/language/lang.service';
import {DropdownSelectComponent} from '../../../layout/dropdown-select/dropdown-select.component';
import {DropdownSelectOptionComponent} from '../../../layout/dropdown-select-option/dropdown-select-option.component';
import {Language} from '../../../../models/language';
import {ProductService} from '../../../../services/product/product.service';
import {Product} from '../../../../models/product';
import {
  ProductPrioritySelectorComponent
} from '../../../layout/product-priority-selector/product-priority-selector.component';

@Component({
  selector: 'app-preping-tool',
  imports: [
    ReactiveFormsModule,
    KeyValuePipe,
    NgClass,
    DropdownSelectComponent,
    DropdownSelectOptionComponent,
    NgOptimizedImage,
    ProductPrioritySelectorComponent
  ],
  templateUrl: './preping-tool.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './preping-tool.component.scss',
})
@IsGranted(['PREPING_TOOL_VIEW'])
@MetaTitle('Preping Tool')
export class PrepingToolComponent implements OnInit {
  languages: Language[] = [];
  products: Product[] = [];
  leadUpPreping: any | null = null;
  productPreping: any | null = null;

  form = new FormGroup({
    email: new FormControl('', Validators.required),
    lang: new FormControl('fr', Validators.required),
    product: new FormControl('', Validators.required),
  });

  constructor(
    private loader: LoaderService,
    private leadService: LeadService,
    private productService: ProductService,
    protected langService: LangService,
  ) {
  }

  ngOnInit(): void {
    // this.form.get('email')?.setValue('seb@oktopsychic.com');

    this.loader.startLoading();

    forkJoin([
      this.langService.getLanguages(),
      this.productService.findAll({sort: 'name'}),
    ]).subscribe(([languages, products]) => {
      this.languages = languages.sort((a, b) => a.name.localeCompare(b.name, 'fr'));
      this.products = products;

      this.loader.stopLoading();
    });
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    const params: any = this.form.value;

    if (params.email) {
      this.loader.startLoading();

      forkJoin([
        this.leadService.leadUpPreping(params.email),
        this.leadService.productPreping(
          params.email,
          params.lang,
          params.product
        ),
      ]).subscribe(([leadUpPreping, productPreping]) => {
        this.leadUpPreping = leadUpPreping;
        this.productPreping = productPreping;

        this.loader.stopLoading();
      });
    }
  }

  getPrepingClass(status: unknown): string {
    return 'preping-status-' + status;
  }
}
